import React from 'react'

const LogoGreyMessage = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96">
    <path d="M48,86.18A38.18,38.18,0,1,0,9.82,48,38.18,38.18,0,0,0,48,86.18Z" fill="#e5e5e5" />
    <path
      d="M12.06,23.65l52.59-7.39a6.66,6.66,0,0,1,7.5,5.65L77.7,61.36a6.66,6.66,0,0,1-5.65,7.5l-52.6,7.39A6.65,6.65,0,0,1,12,70.6L6.41,31.15A6.66,6.66,0,0,1,12.06,23.65Z"
      fill="#fff"
    />
    <path
      d="M79.57,80.36a17.87,17.87,0,1,0-25.19-2A17.88,17.88,0,0,0,79.57,80.36Z"
      fill="#999"
      stroke="#4a4a4a"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="M63.79,66.84a.47.47,0,0,0-.66,0,.49.49,0,0,0,0,.66l3.08,3.08a.46.46,0,0,0,.65,0l6.75-6.79a.46.46,0,0,0-.65-.65L66.53,69.6Z"
      fill="#fff"
      stroke="#fff"
      stroke-width="2.5"
      fill-rule="evenodd"
    />
    <rect width="96" height="96" fill="none" />
    <path d="M48,86.2A38.2,38.2,0,1,0,9.76,48h0A38.2,38.2,0,0,0,48,86.2Z" fill="#e5e5e5" />
    <path
      d="M12.09,23.7l52.6-7.4A6.66,6.66,0,0,1,72.16,22h0l5.5,39.4A6.66,6.66,0,0,1,72,68.9h0l-52.6,7.4a6.66,6.66,0,0,1-7.5-5.68h0L6.36,31.2a6.59,6.59,0,0,1,5.56-7.48h0Z"
      fill="#fff"
    />
    <path
      d="M76.26,44.7,72.86,22a7.47,7.47,0,0,0-8.3-6.3L12,23.2a7.4,7.4,0,0,0-6.3,8.3L11.16,71a7.4,7.4,0,0,0,8.3,6.3l23.8-3.7a.76.76,0,1,0-.3-1.5h0l-23.8,3.7a5.82,5.82,0,0,1-6.5-5l-5.3-38,34.8,17.7a1,1,0,0,0,.9-.1l28.6-26.7L74.76,45a.76.76,0,1,0,1.5-.3ZM42.36,49,7.09,31a5.94,5.94,0,0,1,5.1-6.3l52.6-7.3a5.82,5.82,0,0,1,6.6,4.6Z"
      fill="#4a4a4a"
    />
    <path d="M19.86,66.6l-3,4.2a.72.72,0,0,0,1.2.8h0l3-4.2a.72.72,0,1,0-1.2-.8Z" fill="#4a4a4a" />
    <path
      d="M31.26,50.3,22,63.6a.72.72,0,0,0,1.2.8h0l9.3-13.3a.72.72,0,1,0-1.2-.8Z"
      fill="#4a4a4a"
    />
    <path
      d="M79.56,80.4a17.88,17.88,0,1,0-25.21-2h0A17.89,17.89,0,0,0,79.56,80.4Z"
      fill="#999"
      stroke="#4a4a4a"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="M70.25,66.78l3.43-3.43a1.62,1.62,0,0,0-2.29-2.28L68,64.5l-3.43-3.43a1.62,1.62,0,0,0-2.29,2.28l3.43,3.43-3.43,3.43a1.62,1.62,0,0,0,2.29,2.29L68,69.07l3.43,3.43a1.62,1.62,0,0,0,2.29-2.29Z"
      fill="#fff"
    />
  </svg>
)

export default LogoGreyMessage
